import { 
    ACTUALIZAR_LIST_NIVEL1,
    AGREGAR_NIVEL1,
  } from "./nivel1Actions";

  const areaReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_NIVEL1: {
            return {
                ...state,
                nivel1Lista: action.payload
            }
        };

        case AGREGAR_NIVEL1:{
            return {
                 ...state,
                 nivel1Lista: [action.payload, ...state.nivel1Lista]
             }
         };

        default:
            return state;

    }
  }

  export default areaReducer;